"use client";

import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { useHeroHeaderView } from "@/components/hero-header/HeroHeaderViewProvider";
import { CollectionHeaderCompactContent, CollectionHeaderCompactContentFragment } from "./CollectionHeaderCompactContent";
import { CollectionHeaderFullContent, CollectionHeaderFullContentFragment } from "./CollectionHeaderFullContent";
import { CollectionHeaderLayoutGroup, CollectionHeaderLayoutGroupFragment } from "./CollectionHeaderLayoutGroup";
export const CollectionHeaderContentFragment = graphql(`
    fragment CollectionHeaderContent on Collection {
      ...CollectionHeaderLayoutGroup
      ...CollectionHeaderCompactContent
      ...CollectionHeaderFullContent
    }
  `, [CollectionHeaderCompactContentFragment, CollectionHeaderFullContentFragment, CollectionHeaderLayoutGroupFragment]);
export function CollectionHeaderContent(t0) {
  const $ = _c(8);
  const {
    collection: collectionKey
  } = t0;
  const {
    headerView
  } = useHeroHeaderView();
  let t1;
  if ($[0] !== collectionKey) {
    t1 = readFragment(CollectionHeaderContentFragment, collectionKey);
    $[0] = collectionKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const collection = t1;
  let t2;
  if ($[2] !== collection || $[3] !== headerView) {
    t2 = headerView === "compact" ? <CollectionHeaderCompactContent collection={collection} /> : <CollectionHeaderFullContent collection={collection} />;
    $[2] = collection;
    $[3] = headerView;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== collection || $[6] !== t2) {
    t3 = <CollectionHeaderLayoutGroup collection={collection}>{t2}</CollectionHeaderLayoutGroup>;
    $[5] = collection;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}